export default "__VITE_ASSET__CrTFKbiS__"